import React, { useContext } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

export const AssignedCheckbox: React.FC = () => {
	const { toggleAssigned, assigned, IDSelectedRestaurant } = useContext<IDishesContext>(DishesContext);

	return (
		<Checkbox
			checked={assigned}
			onChange={toggleAssigned}
			disabled={!IDSelectedRestaurant}
			data-test="AssignedCheckbox">
			<Text translationNameSpace="listing" translationKey="assignedDishesOnlyLabel" asFragment={true} />
		</Checkbox>
	);
};
